import { createAction } from '@reduxjs/toolkit'

export const setAllCsmState = createAction('setAllCsmState')

export const setAllAccountantState = createAction('setAllAccountantState')
